import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/css/Main.css";
import "./assets/css/Responsive.css";
import store, { persistor } from "./redux/store/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { ThemeProvider } from "@mui/material";
import theme from "./theme/theme";
import { handleNotificationClick } from "./notificationHelper";

// if ("serviceWorker" in navigator) {
//   window.addEventListener("load", async () => {
//     try {
//       // Check if there's an existing registration
//       // const existingReg = await navigator.serviceWorker.getRegistration();

//       console.log("existingReg=========>", existingReg);
//       if (existingReg) {
//         // const unregisterPromises = existingReg.map(async (registration) => {
//         // console.log('Unregistering:', registration.scope);
//         await existingReg.unregister();
//         // });

//         // await Promise.all(unregisterPromises);
//       }
//       // await new Promise(resolve => setTimeout(resolve, 1000));

//       const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
//         scope: "/",
//         updateViaCache: "none" // Prevent caching issues
//       });
//       await navigator.serviceWorker.ready;
//       // console.log("Service Worker registered successfully:", registration.scope);

//       navigator.serviceWorker.addEventListener("message", (event) => {
//         // console.log("Received message from service worker:", event.data);

//         if (event.data.type === "NOTIFICATION_CLICKED") {
//           const state = store.getState();
//           const loginData = state?.login?.loginData;
//           handleNotificationClick(event.data.data, undefined, store.dispatch, loginData);
//         }
//       });

//       // Force update the service worker
//       await registration.update();
//     } catch (error) {
//       console.error("Service Worker registration failed:", error);
//     }
//   });
// }

// LATEST AND UPDATED

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {

      let registration = await navigator.serviceWorker.getRegistration("/");

      if (!registration) {
        registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js", {
          scope: "/"
        });
        console.log("Service Worker registered successfully:");
      } else {
        // console.log("✅ Service Worker already registered:", registration.scope);
        await registration.update();
      }
      // Wait for service worker to be ready
      await navigator.serviceWorker.ready;
      // console.log("Service Worker ready");
      navigator.serviceWorker.addEventListener("message", (event) => {
        if (event.data.type === "NOTIFICATION_CLICKED") {
          const state = store.getState();
          // const loginData = state?.login?.loginData;
          const loginData = state?.main?.loginData;
          handleNotificationClick(event.data.data, undefined, store.dispatch, loginData);
        }
      });
      if (registration) {
        await registration.update();
      }
    } catch (error) {
      console.error("❌ Service Worker registration failed:", error);
    }
  });
}


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <App />
          </LocalizationProvider>
        </ThemeProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

reportWebVitals();

export { };
